import en from './changeSubscriptionModalEn';

const de = {
  ...en,
  title: 'Abo verwalten',
  loading: 'Laden…',
  notBilledStripe: 'Diese Ressource wird nicht über Stripe abgerechnet.',
  upgradePaid: 'Auf bezahlten Plan upgraden',
  loadingPrices: 'Preise werden geladen…',
  selectPlan: 'Plan wählen',
  upgradeNow: 'Jetzt upgraden',
  noUpgradeOptions: 'Keine Upgrade-Optionen.',
  currentSubscription: 'Aktuelles Abo',
  status: 'Status:',
  cancelAtPeriodEndLabel: 'Ende Periode kündigen:',
  yes: 'Ja',
  no: 'Nein',
  runsUntil: 'Läuft bis:',
  cancelAtPeriodEndBtn: 'Zum Periodenende kündigen',
  restart: 'Fortsetzen',
  extendChangePlan: 'Plan nach aktueller Periode ändern',
  selectNextPlan: 'Nächster Plan',
  scheduleChange: 'Wechsel planen',
  upgradeChangePlan: 'Plan wechseln / upgraden',
  changePlanNow: 'Plan jetzt wechseln',
  cancelModalTitle: 'Abo zum Periodenende kündigen',
  cancelModalDesc: 'Die Ressource bleibt bis zum Ende der Abrechnungsperiode aktiv.',
  reasonRequired: 'Grund (Pflicht)',
  placeholderWhy: 'Warum kündigen Sie?',
  close: 'Schließen',
  confirmCancel: 'Kündigung bestätigen',
  reasonRequiredErr: 'Kündigungsgrund erforderlich.',
  cancelSuccess: 'Abo endet zum Ende der laufenden Periode.',
  restartSuccess: 'Abo-Fortsetzung angefordert.',
  selectNextPlanErr: 'Bitte nächsten Plan wählen.',
  scheduleSuccess: 'Planwechsel nach Periodenende geplant.',
  selectPlanUpgradeErr: 'Bitte Zielplan wählen.',
  createSubSuccess: 'Abo angelegt.',
  updateSubSuccess: 'Abo aktualisiert.',
};

const es = {
  ...en,
  title: 'Gestionar suscripción',
  upgradePaid: 'Mejorar a plan de pago',
  selectPlan: 'Elegir plan',
  upgradeNow: 'Mejorar ahora',
  currentSubscription: 'Suscripción actual',
  cancelAtPeriodEndBtn: 'Cancelar al final del periodo',
  restart: 'Reanudar',
  scheduleChange: 'Programar cambio',
  close: 'Cerrar',
};

const MAP = {
  en,
  de,
  es,
  fr: { ...en, title: 'Gérer l’abonnement', close: 'Fermer', restart: 'Reprendre' },
  it: { ...en, title: 'Gestisci abbonamento', close: 'Chiudi' },
  pt: { ...en, title: 'Gerir subscrição', close: 'Fechar' },
  nl: { ...en, title: 'Abonnement beheren', close: 'Sluiten' },
  pl: { ...en, title: 'Zarządzaj subskrypcją', close: 'Zamknij' },
  sv: { ...en, title: 'Hantera prenumeration', close: 'Stäng' },
  no: { ...en, title: 'Administrer abonnement', close: 'Lukk' },
  da: { ...en, title: 'Administrer abonnement', close: 'Luk' },
  fi: { ...en, title: 'Hallitse tilausta', close: 'Sulje' },
  cs: { ...en, title: 'Spravovat předplatné', close: 'Zavřít' },
  hu: { ...en, title: 'Előfizetés kezelése', close: 'Bezárás' },
  ro: { ...en, title: 'Gestionează abonamentul', close: 'Închide' },
  el: { ...en, title: 'Διαχείριση συνδρομής', close: 'Κλείσιμο' },
  id: { ...en, title: 'Kelola langganan', close: 'Tutup' },
};

export function getChangeSubscriptionModalStrings(lang) {
  return MAP[lang] || en;
}
